export const navigationMenuItems = [
  {
    path: "/",
    label: "home",
  },
  {
    path: "/shop",
    label: "shop",
  },
  {
    path: "/about",
    label: "about",
  },
]
